import { el, setStyle } from "redom"

export const buildBottomSoundcorset = () =>
    el(".bottom#bottom-soundcorset",
        el(".container", { style: "line-height: 20px;" },
            el("p.text center-in-div", { style: "color: #D7F3F3;" }, "Ⓒ Soundcorset")
        )
    )

export const buildTopLinks = () => {
    const topLink = buildAppLinks("top")
    setStyle(topLink, { "overflow-x": "hidden", top: 0, left: 0, right: 0, "z-index": 99 })
    return topLink
}

export const buildBottomLinks = () => buildAppLinks("bottom")

const buildAppLinks = (location: string): HTMLDivElement =>
    el("div", { className: `${location}-link`, id: `${location}-link`, style: "display: block;" },
        el(".container", { style: "line-height: 15px;" },
            el(".row text",
                el(".col-12 col-sm-6",
                    el(".vertical-center-in-div", { style: "padding-left: 10px;" },
                        el("p.caption million", { style: "color: white;" }, "Soundcorset, chosen by 50 million people."),
                        el("p.caption experience", { style: "font-weight: bold; color: #8CFE29;" }, "Experience it now.")
                    )
                ),
                el(".col-6 col-sm-3 links",
                    el("a", { href: "https://play.google.com/store/apps/details?id=com.soundcorset.client.android", target: "_blank" },
                        el("img.gooplay-icon vertical-center-in-div", { src: "/public/icon/icon_googleplay.png", style: "float: right; margin-right: -3px;" })
                    )
                ),
                el(".col-6 col-sm-3 links",
                    el("a", { href: "https://itunes.apple.com/us/app/tuner-metronome-soundcorset/id918055824", target: "_blank" },
                        el("img.applay-icon vertical-center-in-div", { src: "/public/icon/icon_appstore.png", style: "float: left; margin-left: -3px;" })
                    )
                )
            )
        )
    )
